import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";
import LoadingDialog from "../Utils/LoadingDialog";
import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";

import { faInfoCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelfHelp from "../Utils/SelfHelp";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";
import MultiSelectPrime from "../PrimeComponents/MultiSelectPrime";

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const formatDataSelector = (sensors, sectors, nodes, lng) => {
    const sensArr = [];
    const sectArr = [];

    nodes && Array.isArray(nodes) && nodes?.length > 0 && nodes?.forEach(n => {
        n.sensores && Array.isArray(n.sensores) && n.sensores.length > 0 && n.sensores.forEach(s => {
            if (s.monitorear) {
                const { sensor_id, nombre, tipo } = s;
                const _lng = tipo?.[lng] ? lng : "en";
                sensArr.push({ id: `1-${sensor_id}`, nombre: tipo?.[_lng] ? `${tipo[_lng]} [${nombre}] [${n.nombre}]` : nombre });
            }
        });
    });
    /*
    sensors && Array.isArray(sensors) && sensors.length > 0 && sensors.map(s => {
        if (s.monitorear) {
            const { sensor_id, nombre, tipo } = s;
            sensArr.push({ id: `1-${sensor_id}`, nombre: tipo[lng] ? `${tipo[lng]} [${nombre}]` : nombre });
        }
    });
*/
    sectors && Array.isArray(sectors) && sectors.length > 0 && sectors.forEach(s => {
        if (Array.isArray(s.tipo) && s.tipo.includes(1)) {
            const { sector_id, nombre, nombre_alternativo } = s;
            sectArr.push({ id: `2-${sector_id}`, nombre: `ET0 [${nombre || nombre_alternativo}]` });
        }
    });

    return ([].concat(sensArr, sectArr));
};

const getCompleteValues = (values, data) => {
    if (!data || !values) return null;
    const dataNew = [];

    data.forEach(d => {
        if (d) {
            if (values.includes(d.id)) {
                dataNew.push(d);
            }
        }
    });
    return dataNew;
};

const RAWData = () => {
    const location = useLocation();
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [selectedVars,setSelectedVars] = useState([]);
    const [_, dispatch] = useContext(FarmContext);
    const [dataSelector, setDataSelector] = useState(null);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [rangeDates, setRangeDates] = useState(null);
    const [showValidation, setShowValidation] = useState(false);
    const [loadingReq, setLoadingReq] = useState(false);

    const sectors = dispatch({ type: "get", path: "sectors" });
    const sensors = dispatch({ type: "get", path: "sensors" });
    const nodes = dispatch({ type: "get", path: "nodes" });

    useEffect(() => {
        const data = formatDataSelector(sensors, sectors, nodes, i18n.language);
        setDataSelector(data && data);
    }, [t, i18n.language,nodes,sensors,sectors]);

    const selfHelpImgDes1 = import.meta.glob("../../img/autoayuda/*/autoayuda-raw-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-raw-1.png`];
    const selfHelpImgDes2 = import.meta.glob("../../img/autoayuda/*/autoayuda-raw-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-raw-2.png`];
    const selfHelpImgDes3 = import.meta.glob("../../img/autoayuda/*/autoayuda-raw-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-raw-3.png`];
    const selfHelpImgDes4 = import.meta.glob("../../img/autoayuda/*/autoayuda-raw-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-raw-4.png`];
    const selfHelpImgDes5 = import.meta.glob("../../img/autoayuda/*/autoayuda-raw-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-raw-5.png`];

    const selfHelpDescarga = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
          [
              { id: 1, text: t("forms.msgRaw1"), image: selfHelpImgDes1 },
              { id: 2, text: t("forms.msgRaw2"), image: selfHelpImgDes2 },
              { id: 3, text: t("forms.msgRaw3"), image: selfHelpImgDes3 },
              { id: 4, text: t("forms.msgRaw4"), image: selfHelpImgDes4 },
              { id: 5, text: t("selfHelp.pozo.msgDescarga4"), image: selfHelpImgDes5 },
              { id: 6, text: t("selfHelp.pozo.msgDescarga5"), image: [] }
          ]
        }
    ];
    return (
        <div className='row-container'>
            {!dataSelector && <LoadingDialog />}
            <div className='row'>
                <div className="col">
                    <div id="cardRaw" className="card">
                        {loadingReq && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpDescarga &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("farms.etiqueta.rawdata")}</span></h5>
                                </div>
                            </div>
                            <div className='linea-titulo' />

                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="row linea-formulario">
                                        <div className="col-12 col-md-6 text-md-right mtem-05">
                                            <label className="boldie">{t("forms.variable")}</label>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                            <MultiSelectPrime
                                                value={selectedVars}
                                                setValue={setSelectedVars}
                                                options={dataSelector}
                                                optionLabel="nombre"
                                                optionValue="id"
                                                placeholder={t("forms.pHolderSelect")}
                                                selectAllLabel={t("forms.selectAll")}
                                                showSelectAll
                                                selectedItemsLabel={t("forms.itemsSelected",{ total:selectedVars?.length })}
                                                maxSelectedLabels={0}
                                            />
                                        </div>
                                    </div>
                                    <div className="row linea-formulario">
                                        <div className="col-12 col-md-6 text-md-right mtem-05">
                                            <label className="boldie">{t("forms.rangoFechas")}</label>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                            <CalendarPrime
                                                style={{width:"100%"}}
                                                id="daterangepicker"
                                                t={t}
                                                setValue={setRangeDates}
                                                value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                                locale={i18n.language}
                                                selectionMode="range"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {showValidation &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgRawValidation")}</span>
                                    </div>}
                                <div className="col-12 text-center">
                                    <ButtonPrime onClick={() => {
                                        //'/farms/{campoId}/dataraw'
                                        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0];
                                        const hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1];

                                        if (selectedVars && selectedVars.length && desde && hasta) {
                                            setLoadingReq(true);
                                            setShowValidation(false);
                                            const body = {
                                                selectedValue: selectedVars,
                                                dateFrom: desde.toJSON(),
                                                dateTo: hasta.toJSON(),
                                                lng: i18n.language
                                            };
                                            const param = `/farms/${farmId}/rawdata`;
                                            RestAPI.post("apiAdminDropControl", param, { body: body })
                                                .then(res => JSON.parse(JSON.stringify(res)))
                                                .then((data) => {
                                                    setLoadingReq(false);
                                                    setShowErrorMsg(false);
                                                    setShowSuccessMsg(true);
                                                })
                                                .catch(err => {
                                                    setLoadingReq(false);
                                                    setShowErrorMsg(true);
                                                    console.error(err);
                                                });
                                        } else {
                                            setLoadingReq(false);
                                            setShowValidation(true);
                                        }
                                    }} label={t("forms.btnSendRequest")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {showSuccessMsg &&
                        <div id="successForRaw" className="card"
                            data-mdb-toggle="animation" data-mdb-animation-reset="onLoad" data-mdb-animation="fade-in-up "
                        >
                            <div className="row p-2">
                                <div className="col-12 col-md-1">
                                    <div className="text-center pl-md-2 pt-md-2">
                                        <FontAwesomeIcon size="2x" icon={faInfoCircle} style={{ color: "white" }} />
                                    </div>
                                </div>
                                <div className="col-12 col-md-11">
                                    <div className="rawMsg">
                                        {t("forms.msgSuccesRawReq").includes("\n") ?
                                            t("forms.msgSuccesRawReq").split("\n").map(text => {
                                                return <><span>{text}</span><br /></>;
                                            })
                                            :
                                            <span>{t("forms.msgSuccesRawReq")}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {showErrorMsg &&
                        <div id="errorForRaw" className="card"
                            data-mdb-toggle="animation" data-mdb-animation-reset="onLoad" data-mdb-animation="fade-in-up "
                        >
                            <div className="row p-2">
                                <div className="col-12 col-md-1">
                                    <div className="text-center pl-md-2 pt-md-2">
                                        <FontAwesomeIcon size="2x" icon={faExclamationCircle} style={{ color: "white" }} />
                                    </div>
                                </div>
                                <div className="col-12 col-md-11">
                                    <div className="rawMsg">
                                        {t("forms.msgErrorRawReq").includes("\n") ?
                                            t("forms.msgErrorRawReq").split("\n").map(text => {
                                                return <><span>{text}</span><br /></>;
                                            })
                                            :
                                            <span>{t("forms.msgErrorRawReq")}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        </div>
    );
};

export default withName(RAWData, "RAWDataFrag");
